import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { useLocalStorage } from 'usehooks-ts';

import { redirectToDocs } from 'utils/redirectToDocs';

import { LoginForm } from '@organisms/LoginForm';
import { AUTHY_DISABLED } from 'constants/environment';

import { useFetchMfaSettings } from 'hooks/useFetchMfaSettings';
import { useGoogleAnalyticsDispatcher } from 'hooks/useGoogleAnalyticsDispatcher';
import { useRedirectTo } from 'hooks/useRedirectTo';

import { AuthenticationContainer } from '@atoms/AuthenticationContainer';

export const Login = () => {
  const { navigateWithRedirectTo } = useRedirectTo();
  const { state } = useLocation() as { state: { reason?: string } };
  const [searchParams] = useSearchParams();
  const [_, setIsLoggedIn] = useLocalStorage('isLoggedIn', false);

  const fromDocsFlag = searchParams.get('fromDocs') ?? null;

  const fetchMfaSettings = useFetchMfaSettings();

  const dispatchGAEvent = useGoogleAnalyticsDispatcher();

  const onLoginSuccess = async () => {
    const { skipMfa, totpEnabled, hasPhone } = await fetchMfaSettings();

    dispatchGAEvent('logged_in');
    setIsLoggedIn(true);

    if (skipMfa || AUTHY_DISABLED) {
      if (fromDocsFlag) {
        redirectToDocs();
        return;
      }
      navigateWithRedirectTo('/login_transition', {
        state: { loggingIn: true }
      });

      return;
    }

    if (totpEnabled || hasPhone) {
      navigateWithRedirectTo(
        fromDocsFlag ? '/mfa-verify?fromDocs=true' : '/mfa-verify'
      );
    } else {
      navigateWithRedirectTo(
        fromDocsFlag ? '/mfa-setup?fromDocs=true' : '/mfa-setup'
      );
    }
  };

  return (
    <AuthenticationContainer>
      <div className="w-80">
        <LoginForm
          onLoginSuccess={onLoginSuccess}
          loginExpired={state?.reason === 'expired'}
        />
      </div>
      <Link to="/passwords/forgot" className="link-underline mt-24 font-medium">
        Forgot Password?
      </Link>
    </AuthenticationContainer>
  );
};
